import { AppState } from '../rootReducer'

export const getApplicationLoadingState = (state: AppState) =>
  state.application.applicationLoading

export const getApplicationNotificationCountState = (state: AppState) =>
  state.application.notificationCount
